import { get } from '../../../helpers/api/get';
import { get as getPath } from './resourcePath/resourcePath';

const API_LOAD = 'API_LOAD';

const loadData = (store, next, resourceAction, id, query = '') => {
  next({ type: `${resourceAction}_LOADING` });

  return get(`${getPath(resourceAction, id)}${query}`)
    .then(
      response => store.dispatch({ type: `${resourceAction}_LOADED`, response }),
      () => store.dispatch({ type: `${resourceAction}_FAILED` }),
    );
};

export default store => next =>
  action =>
    ((action.resourceAction && action.resourceAction.startsWith(API_LOAD))
      ? loadData(store, next, action.resourceAction, action.id, action.query)
      : next(action));



// WEBPACK FOOTER //
// ./src/reducers/middleware/resourceResolver/resourceResolver.middleware.js